import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import Tag from "../model/Tag";

export const TagDetailsApiService = async (id: number): Promise<Tag> => {
  const url = `/employertag/${id}/details`;
  const { data } = await axios.get(url);

  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useTagDetailsApiService = (id: number, enabled = true) =>
  useQuery<Promise<Tag>, AxiosError, Tag>(
    ["TagsDetailsApiService", id],
    () => TagDetailsApiService(id),
    {
      enabled,
    }
  );
export default useTagDetailsApiService;
